import styled from 'styled-components';

export const SlideMobileAccountStatStyled = styled.div`
    color: #FFFFFF99;
    padding-bottom: 30px;
`;

export const SlideMobileAccountStateFaqAnswersStyled = styled.div`
    margin-left: 24px;
    
    > div {
        margin-top: 8px;
    }
`;
